import React from "react";
import {
    FaTwitch,
    FaXTwitter,
    FaTiktok,
    FaInstagram,
    FaDiscord
} from "react-icons/fa6";
import avatar from "../../views/assets/jizon2.png";
import { PENALTIS_ENABLED } from "../../config/features";

import "./Footer.css";

const ICONS = {
    twitch: FaTwitch,
    twitter: FaXTwitter,
    tiktok: FaTiktok,
    instagram: FaInstagram,
    discord: FaDiscord,
};

const socials = [
    { id: 'twitch', label: 'Twitch', url: 'https://twitch.tv/jizonn' },
    { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/noeliatwentyone/' },
    { id: 'discord', label: 'Discord', url: 'https://discord.gg/Bn4KryKjJ8' },
    { id: 'twitter', label: 'X', url: 'https://x.com/j1zoNN' },
    { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@noeliatwentyone' },
];

const LINK_GROUPS = [
    {
        title: 'Site',
        links: [
            { page: 'home', path: '/', label: 'Início' },
            { page: 'parcerias', path: '/parcerias', label: 'Parcerias' },
            { page: 'comunidade', path: '/comunidade', label: 'Comunidade' },
            ...(PENALTIS_ENABLED ? [{ page: 'penaltis', path: '/penaltis', label: 'Penáltis' }] : []),
            { page: 'setup', path: '/setup', label: 'Setup' },
        ],
    },
    {
        title: 'Apostas',
        links: [
            { page: 'bets', path: '/bets', label: 'Bets' },
            { page: 'desafio', path: '/desafio', label: 'Desafio' },
            { page: 'historico', path: '/historico', label: 'Histórico' },
        ],
    },
];

const EMAIL = 'jizon7649@gmail.com';

export default function Footer({ onNavigate }) {
    return (
        <footer className="site-footer">
            <div className="footer-inner">
                <div className="footer-main">
                    <div className="footer-brand">
                        <div className="footer-brand-row">
                            <img src={avatar} alt="" className="footer-brand-avatar" width="32" height="32" />
                            <span className="footer-brand-name">jizoNN</span>
                        </div>
                        <p className="footer-brand-text">
                            Streams, apostas e os melhores momentos do canal.
                        </p>
                        <div className="footer-social">
                            {socials.map((s) => {
                                const Icon = ICONS[s.id];
                                return (
                                    <a
                                        key={s.id}
                                        href={s.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-link"
                                        aria-label={s.label}
                                        title={s.label}
                                    >
                                        {Icon && <Icon className="footer-icon" aria-hidden="true" />}
                                    </a>
                                );
                            })}
                        </div>
                    </div>

                    {LINK_GROUPS.map(group => (
                        <nav className="footer-col" key={group.title} aria-label={group.title}>
                            <span className="footer-col-title">{group.title}</span>
                            <ul>
                                {group.links.map(l => (
                                    <li key={l.page}>
                                        <a
                                            href={l.path}
                                            onClick={(e) => {
                                                if (!onNavigate) return;
                                                e.preventDefault();
                                                onNavigate(l.page);
                                            }}
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ))}

                    <div className="footer-col">
                        <span className="footer-col-title">Contacto</span>
                        <ul>
                            <li><a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="footer-copy">
                        © {new Date().getFullYear()} jizoNN · Desenvolvido por{" "}
                        <a
                            href="http://stormbit.pt/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-credit-link"
                        >
                            Stormbit
                        </a>
                    </p>
                    <p className="footer-responsible">
                        <span className="footer-age">18+</span>
                        Joga com responsabilidade.
                    </p>
                </div>
            </div>
        </footer>
    );
}
